import { getActivePinia } from 'pinia'

export function useResetStores(stores = getAllStores()) {
	function resetAllItems() {
		stores.forEach((store) => {
			if (store.items) {
				store.items = []
			}
		})
	}

	return {
		resetAllItems,
	}
}

export function getAllStores() {
	let pinia
	try {
		pinia = getActivePinia()
	} catch (error) {
		throw new Error('Pinia is not active.')
	}

	if (!pinia) return []
	const storeMap = pinia._s
	return Array.from(storeMap.values())
}
